import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  Grid2,
  CircularProgress,
} from "@mui/material";
import events2 from "../../assets/images/events_2.png";
import locationSmall from "../../assets/images/location-small.svg";
import userSmall from "../../assets/images/user-small.svg";
import dateSmall from "../../assets/images/date-small.svg";
import buypriceSmall from "../../assets/images/buyprice-small.svg";
import useRequests from "../../utils/useRequests";
import { useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";
import Snackbars from "../../utils/Snackbars";



const Eventresellticketconfirmation = () => {
  const { ut_id } = useParams();
  const [loading, setLoading] = useState(true);
  const { getRequest } = useRequests();
  const [secondsLeft, setSecondsLeft] = useState(0); 
  const formatCountdown = (seconds) => {
      const min = String(Math.floor(seconds / 60)).padStart(2, "0");
      const sec = String(seconds % 60).padStart(2, "0");
      return `${min}:${sec}`;
  };

  const navigate = useNavigate();
  const handleMyTicket = () => {
    navigate("/my-tickets");
  };
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [detail, setDetail] = useState({
    type: "",
    day_pass: "",
    quantity: "",
    name: "",
    address: "",
    location: "",
    start_datetime: "",
    end_datetime: "",
    time: "",
    banner: "",
    event_ticket_date: "",
    purchase_price: "",
    is_seats_required: "No",
    seat_number: "",
  });

  const fetchTicketDetails = async () => {
    setLoading(true);
    try {
      const response = await getRequest(`ticket-details/${ut_id}`);
      if (response && response.code === 200) {
        const data = response.data;
        const calculatedMaxDays = calculateMaxEventDays(data.start_datetime, data.end_datetime);
        setMaxEventDays(calculatedMaxDays);
        setDetail({
          e_id: data.e_id,
          type: data.type,
          day_pass: data.day_pass,
          quantity: data.quantity,
          name: data.name,
          address: data.address,
          location: data.location,
          start_datetime: data.start_datetime,
          end_datetime: data.end_datetime,
          time: data.start_time + " - " + data.end_time,
          banner: data.banner,
          event_ticket_date: data.event_ticket_date,
          purchase_price: data.purchase_price,
          qrcode: data.qrcode,
          is_seats_required: data.is_seats_required,
          seat_number: data.booked_seat || "",
          ticket_time: data.time
        });
        console.log("banner", data.banner);
      } else {
        setAlertData({
          variant: "error",
          message: response.message || "Failed to fetch ticket details",
        });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
    setLoading(false);
    resetAlertData();
  };

  const fetchSettings = async () => {
    const response = await getRequest("site-settings");
    if (response && response.code === 200) {
      
      response.data.forEach(element => {
        if(element.setting_name == "qr_code_validity"){
          setSecondsLeft(Number(element.setting_value) * 60);
        }
      });
      
    } else {
      setAlertData({ variant: "error", message: "Failed to fetch settings" });
      resetAlertData();
    }
  };

    const [maxEventDays, setMaxEventDays] = useState(1);
    const calculateMaxEventDays = (startDate, endDate) => {
        if (!startDate || !endDate) return 1;
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
        
        return Math.min(diffDays, 10); // Max 10 days
    };

  useEffect(() => {
    fetchSettings();
    fetchTicketDetails();
  }, [ut_id]);

  useEffect(() => {
      const interval = setInterval(() => {
      setSecondsLeft((prev) => {
          if (prev <= 1) {
          clearInterval(interval);
          return 0;
          }
          return prev - 1;
      });
      }, 1000);

      return () => clearInterval(interval);
  }, []);

  const formatEventDate = (start, end, time, ticketDate) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate; // Difference in milliseconds
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
    const day = `${diffInDays + 1}`.toLowerCase();

    const startDay = format(startDate, "dd");
    const endDay = format(endDate, "dd");
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy");
    let daysCount = day;
    if (day > 1) {
      daysCount = "10";
    }

    const ticket_date = new Date(ticketDate);
    const ticketDay = format(ticket_date, "dd");

    if (startDay == endDay) {
      return {
        formattedDate: `${startDay} ${startmonth} ${year}`,
        daysCount: `${daysCount} Day's Event`,
        time,
        ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
      };
    }

    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth} ${year}`,
      daysCount: `${daysCount} Day's Event`,
      time,
      ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
    };
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          minHeight: "300px",
        }}
      >
        <CircularProgress color="primary" />
        <p>Loading ...</p>
      </Box>
    );
  }
  if (!detail) return <Typography>No ticket details found.</Typography>;
  const { formattedDate, daysCount, time, ticketFormatedDate } =
    formatEventDate(
      detail.start_datetime,
      detail.end_datetime,
      detail.time,
      detail.event_ticket_date
    );

    const getSelectedTicketTime = () => {
        if (!detail) return null;
        if (detail.ticket_time) return detail.ticket_time;
        return null;
    };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(98vh - 33px)",
        }}
        className="celebration-bg"
      >
        <Box sx={{ width: 500, padding: "30px 15px", borderRadius: 2 }}>
          <Typography variant="h4" className="title congratulation">
            CONGRATULATIONS
          </Typography>
          <Typography variant="h4" className="title confirm">
            YOUR {detail.e_id == "8"? "INVITATION":"TICKET"} IS CONFIRMED
          </Typography>
          <Typography variant="h4" className="title arrive">
            Please arrive on time{detail.e_id == "8"? "INVITATION":"TICKET"}.
          </Typography>
          <div container spacing={2}>
            <div item xs={12}>
              <Box className="events-box">
                <Card
                  sx={{
                    borderRadius: "10px",
                    padding: "15px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="position-relative radius-img-box">
                    <CardMedia
                      component="img"
                      height="185"
                      image={detail.banner}
                      alt={detail.name}
                    />
                  </div>
                  <CardContent style={{ padding: "9px 5px" }}>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        color: "#6638A2",
                        marginTop: "5px",
                        fontSize: "21px",
                        marginBottom: "10px",
                        lineHeight: "32px",
                        fontWeight: "500",
                      }}
                    >
                      {detail.name}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={userSmall} alt="" className="small-svg" />
                      {`${detail.type} Ticket, ${detail.day_pass} Day Pass, ${detail.quantity} Person`}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={dateSmall} alt="" className="small-svg" />
                      {detail.day_pass == 1
                        ? ticketFormatedDate
                        : formattedDate}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', marginTop: '8px', fontSize: "16px", color: "#341439" }}>
                        <img src={dateSmall} alt='' className='small-svg' />
                        {getSelectedTicketTime() || time}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img
                        src={buypriceSmall}
                        alt=""
                        className="small-svg"
                        style={{ width: "16px", marginLeft: "1px" }}
                      />
                      {` Buying Price ₹${detail.purchase_price}`}
                    </Typography>
                    {/* <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={locationSmall} alt="" className="small-svg" />
                      {detail.address}
                    </Typography> */}
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={locationSmall} alt="" className="small-svg" />
                      <a
                        href={detail.location}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "#1976d2", fontWeight: "bold"  }}
                        >
                        {detail.address}
                      </a>
                    </Typography>
                    {detail.is_seats_required === "Yes" && (
                        <Typography variant="body2" color="text.secondary" sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            marginTop: '11px', 
                            fontSize: "16px", 
                            color: "#341439",
                            backgroundColor: '#f8f9fa',
                            padding: '8px 12px',
                            borderRadius: '6px',
                            border: '1px solid #e9ecef'
                        }}>
                            <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center',
                                gap: 1,
                                width: '100%'
                            }}>
                                <Box sx={{
                                    width: '20px',
                                    height: '20px',
                                    backgroundColor: '#6638A2',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    S
                                </Box>
                                <span style={{ fontWeight: "600", color: "#6638A2" }}>Seat Number:</span> 
                                <span style={{ 
                                    fontWeight: "bold", 
                                    color: "#341439",
                                    backgroundColor: '#fff',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    border: '1px solid #6638A2'
                                }}>
                                    {detail.seat_number}
                                </span>
                            </Box>
                        </Typography>
                    )}
                  </CardContent>
                  <div className="position-relative qr-generate">
                    <img src={detail.qrcode} alt="QR-Code" className="qr-img" />
                    <Typography
                      sx={{
                          marginTop: 1,
                          textAlign: "center",
                          color: secondsLeft > 0 ? "#FF5722" : "red",
                          fontWeight: "bold",
                      }}
                      >
                      {secondsLeft > 0
                          ? `QR Code valid till: ${formatCountdown(secondsLeft)} Minutes`
                          : "QR Code expired"}
                    </Typography>
                  </div>
                  {secondsLeft > 0
                      ? ""
                      : 
                      <Button
                      className="btn-common-border"
                      type="button"
                      variant="outlined"
                      color="secondary"
                      onClick={() => window.location.reload()}
                      fullWidth
                      sx={{ marginTop: 2 }}
                      >
                      Refresh QR Code
                      </Button>
                  }
                </Card>
              </Box>
            </div>
            <Grid2 className="button-bottom fullWidth mt-3" fullWidth>
              <Button
                className="btn-common-border"
                type="submit"
                variant="contained"
                color="primary"
                onClick={handleMyTicket}
                fullWidth
                sx={{ marginTop: 2 }}
              >
                Go To My Tickets
              </Button>
            </Grid2>
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default Eventresellticketconfirmation;
